import api from 'Services/api';
import { InvoiceContingencePayload, ResponseTypeInvoiceContingence } from './types';

export const sendInvoiceInContingence = async (
  payload: Omit<InvoiceContingencePayload, 'tipoUsuario' | 'nomeUsuario'>,
  user: string
): Promise<ResponseTypeInvoiceContingence> => {
  const token = localStorage.getItem('token');
  const tokenParse = token ? JSON.parse(token) : null;
  const tipoUsuario = tokenParse?.idTokenClaims?.jobTitle || 'Faturista';

  try {
    const dataToSend: InvoiceContingencePayload = {
      numeroNF: payload.numeroNF,
      numeroSerie: payload.numeroSerie,
      nmRespReceb: payload.nmRespReceb,
      nomeUsuario: user,
      justificativa: payload.justificativa,
      tipoUsuario,
      image: payload.image
    };

    const response = await api.post('/motorista/coleta-canhoto-contingencia', dataToSend, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenParse?.accessToken}`
      }
    });
    return response.data
  } catch (error: any) {
    throw new Error(JSON.stringify(error))
  }
};